var map = {
	"./activity.svg": "6736",
	"./activity_2.svg": "ee1ae",
	"./ali_after_sales.svg": "f7d6",
	"./ali_cabinet.svg": "ab54",
	"./ali_cmd.svg": "0a5f",
	"./ali_customer.svg": "bb68",
	"./ali_device.svg": "b8fa",
	"./ali_fire.svg": "7e45",
	"./ali_home_fill.svg": "b2b7",
	"./ali_marketing.svg": "17ef",
	"./ali_order.svg": "4896",
	"./ali_qrcode.svg": "2d05",
	"./ali_report.svg": "9bb3",
	"./ali_role.svg": "4435",
	"./ali_system.svg": "2ad9",
	"./ali_user.svg": "036f",
	"./bug.svg": "1779",
	"./businessMgt.svg": "2935",
	"./captchaN.svg": "4053",
	"./customer.svg": "b17f",
	"./customer_2.svg": "6e87",
	"./dark.svg": "4123",
	"./dashboard.svg": "f782",
	"./dashboard_2.svg": "02f43",
	"./deviceMgt.svg": "819a",
	"./eye.svg": "4df5",
	"./eyeOpen.svg": "348e",
	"./fullscreen.svg": "9921",
	"./guanbi.svg": "c8cf",
	"./light.svg": "7748",
	"./message.svg": "47ff",
	"./message_2.svg": "c428",
	"./money.svg": "3046",
	"./money_2.svg": "710b",
	"./none.svg": "02eb",
	"./passwordN.svg": "e044",
	"./people.svg": "d056",
	"./peoples.svg": "2f11",
	"./product_manage.svg": "d86f",
	"./product_manage_2.svg": "e618",
	"./report.svg": "9e5c",
	"./shopping.svg": "12a5",
	"./shopping_cart.svg": "b41b",
	"./shopping_cart_2.svg": "3626",
	"./store_manage.svg": "0dfb",
	"./store_manage_2.svg": "0fb0",
	"./study.svg": "b2e3",
	"./study_2.svg": "105f",
	"./system.svg": "30a9",
	"./system_2.svg": "6f18",
	"./userN.svg": "2dad",
	"./user_plus.svg": "5b1d",
	"./user_plus_2.svg": "aa4a",
	"./users.svg": "5055",
	"./users_2.svg": "31a2",
	"./wechat.svg": "80da",
	"./wechat_2.svg": "4a09",
	"./youyidong.svg": "1790",
	"./zuoyidong.svg": "9256"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";